<template>
  <div class="upload">
    <el-upload
      :disabled="disabled"
      ref="upload"
      :action="action"
      :list-type="'text'"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :limit="limit"
      multiple
      :on-success="handleSuccess"
      :auto-upload="true"
      :headers="headers"
      :on-exceed="handleExceed"
      :on-change="handleChange"
      :before-upload="beforeAvatarUpload"
      :accept="
        accept == 'image'
          ? '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF'
          : accept == 'pdf'
          ? '.pdf,.PDF'
          : accept == 'kmz'
          ? '.kmz,.KMZ'
          : '*'
      "
      :file-list="fileList"
      :before-remove="handleBeforeRemove"
    >
      <el-button :disabled="disabled" slot="trigger" style="width:100%"
        >Click to upload</el-button
      >
    </el-upload>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :modal="true"
      :width="zoomInWidth"
    >
      <img :src="dialogImageUrl" style="width:100%" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "UploadImage",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      headers: {
        Authorization: this.bearer + store.state.token
      },
      action: this.baseURL + this.fileParams.action,
      maxSize: this.fileParams.maxSize ? this.fileParams.maxSize : 5,
      zoomInWidth: "1000px",
      successRes: ""
    };
  },
  props: {
    fileParams: Object, // fileParams = {action: '/coupon/uploadPic', maxSize: 1}
    fileList: Array,
    limit: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: "*"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit();
      // if(this.fileList.length > 0){
      //     var res = {
      //         status: '00',
      //         msg: '',
      //         keyName: this.fileList[0].keyName
      //     }
      //     if(this.fileParams.name)res.name = this.fileParams.name
      //     this.$emit('uploadResult',res);
      // }else{
      //     if(this.successRes){
      //         this.$emit('uploadResult',this.successRes);
      //     }else{
      //         this.$refs.upload.submit();
      //     }
      // }
    },
    handleRemove(file, fileList) {
      // this.successRes = '';
      // this.$emit('isUploadImg',false);
      this.$emit("getSuccessRes", fileList); //更新父組件filelist
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = ""; //清空cache
      if (this.accept == "image") {
        if (file.url) {
          //編輯時的預覽
          this.dialogImageUrl = file.url;
          let img = new Image();
          img.src = this.dialogImageUrl;
          let that = this;
          img.onload = function() {
            if (img.width > 960) {
              that.zoomInWidth = "1000px";
            } else {
              that.zoomInWidth = img.width + 40 + "px";
            }
          };
        } else {
          //新增時的預覽
          var reader = new FileReader();
          reader.readAsDataURL(file.raw);
          let that = this;
          let img = new Image();
          reader.onload = function(e) {
            that.dialogImageUrl = this.result;
            img.src = that.dialogImageUrl;
          };
          img.onload = function() {
            if (img.width > 960) {
              that.zoomInWidth = "1000px";
            } else {
              that.zoomInWidth = img.width + 40 + "px";
            }
          };
        }
        this.dialogVisible = true;
      } else {
        if (file.url) {
          window.open(file.url, "_blank");
        }
      }
    },
    handleExceed(files, fileList) {
      this.$message({
        message: `Only ${this.limit} files can be uploaded`,
        type: "warning"
      });
    },
    handleSuccess(response, file, fileList) {
      console.log(response);
      if (response.status == "00") {
        //判斷數組里的每一個file都upload成功后再返回filelist
        let flag = true;
        fileList.forEach(item => {
          if (!item.response && !item.url) flag = false;
        });
        if (flag) {
          this.$emit("getSuccessRes", fileList); //更新父組件filelist
        }
      } else {
        this.$message.error(response.msg);
      }
      // this.successRes = '';
      // if(response.status == '02'){
      //     this.$message.error(response.msg);
      //     store.dispatch("UserLogout");
      //     router.push('/login');
      // }else if(response.status == '00'){
      //     var res = {
      //         status: response.status,
      //         msg: response.msg,
      //         keyName: response.payload
      //     }
      //     if(this.fileParams.name)res.name = this.fileParams.name
      //     this.successRes = res;
      //     this.$emit('uploadResult',res);
      // }else{
      //     this.$message.error(response.msg);
      // }
    },
    handleChange(file, fileList) {
      // if(file.status == "ready" || (file.status == "success" && this.successRes)){
      //     // if(!this.allowPDF){
      //     //     this.$commonjs.fluidImage(fileList,document.getElementsByClassName('el-upload-list__item-thumbnail'));
      //     // }
      //     if(this.fileParams.name){
      //         var data = {
      //             state:true,
      //             name:this.fileParams.name,
      //             status:file.status
      //         }
      //         this.$emit('isUploadImg',data);
      //     }else{
      //         this.$emit('isUploadImg',true);
      //     }
      // }
    },
    beforeAvatarUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < this.maxSize;
      // const type = file.type;
      debugger;
      console.log("beforeAvatarUpload");
      const typeName = file.name
        .substring(file.name.lastIndexOf("."))
        .toLocaleLowerCase();
      if (!isLt1M) {
        this.$message.error(
          "Upload image size cannot exceed " + this.maxSize + "MB!"
        );
        return false;
      }
      if (
        this.accept == "image" &&
        typeName !== ".png" &&
        typeName !== ".jpg" &&
        typeName !== ".jpeg" &&
        typeName !== ".gif"
      ) {
        this.$message.error("Please upload the image in JPG/JPEG/PNG format");
        return false;
      }
      if (this.accept == "pdf" && typeName !== ".pdf") {
        this.$message.error("Please upload the file in PDF format");
        return false;
      }
      if (
        this.accept == "*" &&
        typeName !== ".png" &&
        typeName !== ".jpg" &&
        typeName !== ".jpeg" &&
        typeName !== ".gif" &&
        typeName !== ".pdf" &&
        typeName !== ".csv" &&
        typeName !== ".xls" &&
        typeName !== ".xlsx" &&
        typeName !== ".kmz"
      ) {
        this.$message.error("Please upload the file in correct format");
        return false;
      }
      if (this.accept == "kmz" && typeName !== ".kmz") {
        this.$message.error("Please upload the file in correct format");
        return false;
      }
      return true;
    },
    handleBeforeRemove(file, fileList) {
      if (!this.canDelete) {
        this.$emit("beforeRemove");
        return false;
      }
    }
  },
  created: function() {
    // if(this.fileList.length > 0){
    //     this.$commonjs.fluidImage(this.fileList,document.getElementsByClassName('el-upload-list__item-thumbnail'));
    // }
  }
};
</script>

<style scoped>
.upload {
  text-align: left;
}
.upload > div {
  font-size: 0;
  line-height: 1;
}
.upload > div >>> .el-upload {
  font-size: 14px;
}
.upload >>> .el-upload-list--picture-card .el-upload-list__item {
  margin-bottom: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/upload/Image.vue